module.exports = __webpack_public_path__ + "media/img/home/img_company-dinner-and-dance-6d04009234cc9d7d4f57aca55c706f5f.png";